module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6f8099642bca2cac1893f944dd47d330.png";